import { EditTreeReplacementForm } from './EditTreeReplacementForm';
import { TreeReplacementLoadState } from './TreeReplacementLoadState';
import { useTreeReplacementDetail } from './use-tree-replacements';

/** Loads the replacement in full, then shows the edit form on it. */
export function EditTreeReplacementContent({
  workshopId,
  treeReplacementId,
  formId,
  onSavingChange,
  onDone,
}: {
  workshopId: string;
  treeReplacementId: string;
  formId: string;
  onSavingChange: (saving: boolean) => void;
  onDone: () => void;
}) {
  const detail = useTreeReplacementDetail(workshopId, treeReplacementId);
  // Opened from a cached copy, the form would start from stale values; wait for this
  // open's own fetch so the form only ever starts from the current replacement.
  if (detail.data && detail.isFetchedAfterMount) {
    return (
      <EditTreeReplacementForm
        workshopId={workshopId}
        formId={formId}
        detail={detail.data}
        onSavingChange={onSavingChange}
        onDone={onDone}
      />
    );
  }
  return <TreeReplacementLoadState error={detail.error} />;
}
